<template>
	<div>
		<buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save" ref="SetBtn"></buttonlist>
		<!-- <el-tabs :tab-position="'top'" style="margin-top: 2px"> -->
			<!-- <el-tab-pane :label="$t('getapi[945]')" name="0"> -->
				<wTable id="xpane-0"
				:data="dataSet"
				:loading="loading"
				:header="tableHeader"
				queryData="InvAlarmInfo"
				:filter_thousandth="['sum_orderonqty','diff_qt','assign_qty','sum_onhand','stock_lowerlimit']"
				:option="tableOption"  
				@contextmenu.prevent.native="openMenu($event)"
				ref="singleTable"></wTable>
				
			<el-row class="page">
				<el-col :span="18">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[100, 200, 300, 400]"
						:page-size="pageSize"
						:pager-count="5"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</el-col>
				<el-col :span="6">
					<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
				</el-col>
			</el-row>
		<!-- </el-tabs> -->
		<serce :isVisible="isVisible" queryData="InvAlarmInfo" ref="ser" @getser="serclick"></serce>
		<!-- 改变表格顺序 -->
		<ctable :isVisible="false" :title="$t('getapi[982]')" queryData="InvAlarmInfo" tabNo="0" ref="ctab" @getctab="sortclick"></ctable>
	
		<!-- 详情页面 -->
		<purordermanage :isVisible="isVisible" ref="order" @getdetail="getdetail"></purordermanage>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'InvPartView',
	computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight3-Common.reduceTableHeight3,
                maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight3,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: this.$http.getPageSize('InvPartView'), // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			isShowEdit: false, // 是否显示编辑页面
			dataDetail: {
				Head: {},
				Lists: []
			}, // 编辑页面数据详情
			PlanTypeArray: [], // 计划类型数组
			isEdit: true, // 是否新增操作
            scrollTop:0,
			tableHeader: [],
		};
	},
    watch: {
        dataSet: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
	mounted: function() {
		let that = this;
		that.userData = sessionStorage.getItem('userData');
		that.PlanTypeArray = Array.methods.getPlanType();
		that.authority();
		that.colsort();
	},
    activated () {
        let that = this
		that.colsort();
        setTimeout(() => {
            that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
		colsort(){
			let that = this;
			that.$loadviewfields.Fileds('InvAlarmInfo',0,PFileds=>{
				that.tableHeader = PFileds;
			});	
		},
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[994]"),this.$t("getapi[15]"));
        },
		// 修改表格顺序
		opentable(){
			this.$refs.ctab.clearInputs(true);
		},
		sortclick(val){
			if(val==1){
				this.colsort();
			}
		},
		//type 1 一览权限 、2 编辑界面权限
		authority() {
			let that = this;
			that.$refs.SetBtn.SetOneBtnEnable('ctabel',true);
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
			that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
		},
		handleSizeChange(val) {
			this.pageSize = val;
            this.$http.savePageSize('InvPartView',val)
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.$refs.ser.clearInput(that.isVisible, 'InvAlarmInfo');
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
            that.pageIndex = 1
			that.isVisible = false;
			that.getView();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				Param: datac
			};
			that.$http.urlpost('/Inv/Manager/InvPartView', data, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.loading = false;
					that.DbTbNames = res.DbTbNames;
				}
				that.authority();
			});
		},
		// 根据ID获取详情数据
		editInfo(row) {
			let that = this;
			that.isShowEdit = true;
			that.isEdit = true;
			let parm = {
				Code: row.PO_Code,
				List: []
			};
			this.$refs.order.clearInput(this.isShowEdit, parm);
		},
		// 新增
		add() {
			let that = this;
			let datetime = (
				new Date().getFullYear() +
				'-' +
				(new Date().getMonth() + 1) +
				'-' +
				new Date().getDate() +
				' ' +
				new Date().getHours() +
				':' +
				new Date().getMinutes() +
				':' +
				new Date().getSeconds()
			).toString();
			that.isEdit = false;
			that.isShowEdit = true;
			that.dataDetail = {
				Head: {},
				Lists: []
			};
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		// 导出
		exps() {
			let that = this;
            let datac = [];
            for (let i = 0; i < that.queryData.length; i++) {
                datac.push({
                    query_Condition: that.queryData[i].query_Condition,
                    query_field_type: that.queryData[i].Query_Field_Type,
                    query_field_name: that.queryData[i].Query_Field_Name,
                    query_sort: that.queryData[i].query_sort,
                    row_sign: that.queryData[i].row_sign
                });
            }
            let parm = {
                query_sign: "InvAlarmInfo",
                fromname: that.$t('getapi[994]'),
                SelectIndex: 0,
                MultyVer: that.$processdata.getLanguage(),
                Param: datac
            };
            that.$processdata.commonExport(parm);
		},
		// 保存
		save() {
			let that = this;
			let parm = that.dataDetail;
			that.$http.urlpost('/Pur/Requisition/SaveData', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(Common.SuccessMsg);
				}
			});
		},
		//
		editInfo1() {},
		editInfo2() {},
		editInfo3() {}
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
</style>
